export default __webpack_public_path__ + "static/media/oval_list.fa576797.svg";